export default __webpack_public_path__ + "static/media/me.26a4dbb5.png";